import * as encoding from 'encoding-japanese';

export class ExportData {
  private static LINE_SEPARATOR = '\r\n';
  private static COLUMN_SEPARATOR = ',';
  private static fileName = 'export.csv';

  static toCsv(api: any, fileName?: string) {
    let csvString = '';
    let idx = 1;
    let length = 0;
    const columnsToExport = api.columnController.getAllDisplayedColumns();

    // adding column headers.
    length = columnsToExport.length;
    columnsToExport.map(column => {
      csvString += `\"${column.colDef.headerName}\"`;
      if (idx < length) {
        csvString += this.COLUMN_SEPARATOR;
      }
      idx++;
    });
    csvString += this.LINE_SEPARATOR;
    // adding content of data currently loaded in the grid.
    api.forEachNode(node => {
      idx = 1;
      length = node.columnController.allDisplayedColumns.length;
      node.columnController.allDisplayedColumns.map(column => {
        const cellContent = node.valueService.getValue(column, node) || null;
        csvString += (cellContent !== null) ? `\"${cellContent}\"` : '\"\"';
        if (idx < length) {
          csvString += this.COLUMN_SEPARATOR;
        }
        idx++;
      });
      csvString += this.LINE_SEPARATOR;
    });
    this.download(csvString);
  }

  static str_to_unicode_array(str) {
    const arr = [];
    for (let i = 0; i < str.length; i++) {
      arr.push(str.charCodeAt(i));
    }
    return arr;
  };

  static download (csvString) {
    // Unicode コードポイントの配列に変換する
    const unicode_array = this.str_to_unicode_array(csvString);
    // S-JIS コードポイントの配列に変換
    const sjis_code_array = encoding.convert(
      unicode_array, // ※文字列を直接渡すのではない点に注意
      'SJIS', // to
      'UNICODE' // from
    );
    // 文字コード配列をTypedArrayに変換する
    const uint8_array = new Uint8Array(sjis_code_array);
    // 指定されたデータを保持するBlobを作成する
    const blob = new Blob([uint8_array], { type: 'text/csv' });
    // Internet Explorer
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
    } else {
      // Chrome
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = 'export.csv';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  constructor() {}
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/classes/exportData/exportData.ts